import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom"
import API from '../servicios/api';
import {Header, Titulo, ContenedorHeader, ContenedorBotones} from '../elementos/Header'
import {ContenedorBotonesLista, BotonEditar, BotonEliminar} from '../elementos/ElementosDeLista'
import {ReactComponent as IconoEditar} from '../imagenes/editar.svg'
import {ReactComponent as IconoBorrar} from '../imagenes/borrar.svg'
import Boton from '../elementos/Boton'
import Alerta from '../elementos/Alerta'
import Cargando from '../elementos/Cargando'
import VentanaModal from '../elementos/VentanaModal'

const ListarAutores = () => {
    const [datosCargados, setdatosCargados] = useState(false);
    const [autores, setAutores] = useState([]);
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const [estadoModal, setEstadoModal] = useState(false);
    const [idEliminar, setidEliminar] = useState();

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        cargarDatos();
    }, []);

    //Este hook se ejecuta solamente al primer renderizado
    const cargarDatos = () => {
        fetch(API+"?consultarAutores")
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setdatosCargados(true);
            setAutores(datosRespuesta);
        })
        .catch(console.log)
    }

    const handleModal = (id) => {
        setidEliminar(id);
        setEstadoModal(true);
    }

    const borrarRegistro = ()=> {
        setEstadoModal(false);
        setEstadoAlerta(false);
        setAlerta({});
        
        fetch(API+"?borrarAutor="+idEliminar)
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            if(datosRespuesta.success === 1){
                setEstadoAlerta(true);
                setAlerta({
                    tipo: 'exito',
                    mensaje: 'Autor eliminado correctamente.'
                });
                cargarDatos();
            }
            else{
                setEstadoAlerta(true);
                setAlerta({
                    tipo: 'error',
                    mensaje: 'No es posible eliminar este autor.'
                });
            }
        })
        .catch(console.log)
    }

    if(!datosCargados){
        return(
            <Cargando />
        );
    }
    else{
        return (
            <>
                <Header>
                    <ContenedorHeader>
                        <Titulo>Lista de Autores</Titulo>
                        <ContenedorBotones>
                            <Boton to="/crear-autor" primario="true">Agregar Autor</Boton>
                        </ContenedorBotones>
                    </ContenedorHeader>
                </Header>

                {autores.success === 0 ?
                <p className='ms-3'>No hay información para mostrar.</p>
                :
                <div className="contenedor-tabla">
                    <div className="card card-tamano">
                        <div className="card-body">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Nombre de Autor</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        autores.map(
                                            (autor)=>(
                                                <tr key={autor.Aut_ID}>
                                                    <td>{autor.Aut_Nombre}</td>
                                                    <td>
                                                        <ContenedorBotonesLista>
                                                            <BotonEditar title="Actualizar Autor" as={Link} to={"/editar-autor/"+autor.Aut_ID}>
                                                                <IconoEditar />
                                                            </BotonEditar>
                                                            
                                                            <BotonEliminar title="Eliminar Autor" onClick={() => handleModal(autor.Aut_ID)}>
                                                                <IconoBorrar />
                                                            </BotonEliminar>
                                                        </ContenedorBotonesLista>
                                                    </td>
                                                </tr>
                                            )
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                }
                <Alerta 
                        tipo={alerta.tipo}
                        mensaje={alerta.mensaje}
                        estadoAlerta={estadoAlerta}
                        setEstadoAlerta={setEstadoAlerta}
                />

                <VentanaModal
                        mensajeHeader="Eliminar Autor"
                        mensajeBody="¿Está seguro de eliminar el autor?"
                        estadoModal={estadoModal}
                        setEstadoModal={setEstadoModal}
                        handleConfirm={borrarRegistro}
                />
            </>
        );
    }
}
 
export default ListarAutores;